function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.655 5.223a2.973 2.973 0 0 1 2.973-2.973h2.162a2.973 2.973 0 0 1 2.973 2.973v.27h4.595a.811.811 0 1 1 0 1.622h-1.351v12.162a2.973 2.973 0 0 1-2.973 2.973H8.385a2.973 2.973 0 0 1-2.973-2.973V7.115H4.061a.811.811 0 1 1 0-1.622h4.594zM7.034 7.115v12.162a1.351 1.351 0 0 0 1.351 1.351h8.649a1.351 1.351 0 0 0 1.351-1.351V7.115zm8.108-1.622h-4.865v-.27a1.351 1.351 0 0 1 1.351-1.351h2.162a1.351 1.351 0 0 1 1.351 1.351zm-4.595 4.325a.811.811 0 0 1 .811.811v6.486a.811.811 0 0 1-1.622 0v-6.487a.811.811 0 0 1 .811-.81zm4.324 0a.811.811 0 0 1 .811.811v6.486a.811.811 0 0 1-1.622 0v-6.487a.811.811 0 0 1 .812-.81z",
    transform: "translate(-2.75 -2.25)",
    style: {
      fillRule: "evenodd"
    },
    "data-name": "Delete icon"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteicon);
export default __webpack_public_path__ + "static/media/Delete icon.f43d4ea1c436543075db64ffafc9f8cc.svg";
export { ForwardRef as ReactComponent };